import { useSWRNoRevalidate } from "@nova/swr"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import useSWR from "swr"

export const createS3DownloadUrlInBrowser = async (s3Key: string, isDemo?: boolean) => {
    return await fileManagementApi.getDownloadUrl(s3Key, { isDemo })
}

export const useS3VideoUrl = (s3Key: string | undefined, isDemo: boolean) => {
    return useSWRNoRevalidate(
        [s3Key],
        async () => s3Key && createS3DownloadUrlInBrowser(s3Key, !!isDemo)
    )
}

export const useS3FileUrl = (s3Key: string) => {
    return useSWR([s3Key], async () => s3Key && createS3DownloadUrlInBrowser(s3Key, false))
}
